import React from 'react';

export default class UpdateBlocker extends React.Component {
	shouldComponentUpdate() {
		return false;
	}

	render() {
		return this.props.children;
	}
}
